import React from 'react';
import { useWorkViewContext, Provider as WorkViewProvider } from './Provider';
import { IDs } from '../../Data/Misc';
import { Link, useNavigate } from 'react-router-dom';
import Icon from '../../Components/Icons/Icon';
import Title from '../../Components/Formatting/Customer/Title';
import Subtitle from '../../Components/Formatting/Customer/Subtitle';
import Services from '../../Components/Formatting/Services';
import Money from '../../Components/Formatting/Money';
import Dropdown from '../../Components/Dropdown';
import { getEntityLink, useDirectionsTo } from '../../Services/helpers';
import { useOffline } from '../../Components/Offline';
import { Roles } from '../../Data/Users';

const WorkWidget = () => {
    const date = new Date().toISOString().split('T')[0];

    return <WorkViewProvider date={date} filterOverride={{assignedTo: IDs.ONE, roundId: null}}>
        <div className="flex flex-col surface-1 p-2 rounded-lg border">
            <Link to="/work" className="inline-flex flex-row items-center justify-between text-muted pb-2 border-b border-muted">
                <div>Next up</div>
                <div className="flex flex-row items-center gap-2">
                    Work view
                    <Icon icon="RightChevron" />
                </div>
            </Link>
            <div className="p-2">
                <Inner />
            </div>
        </div>
    </WorkViewProvider>;
};

const Inner = () => {
    const {filteredJobs} = useWorkViewContext();

    if (filteredJobs.length === 0) {
        return <div className="text-center text-sm text-muted my-4">No more jobs today 🎉</div>
    }

    return <div className="flex flex-col divide-y divide-muted">
        {filteredJobs.slice(0, 2).map(j => <Job key={j.id} job={j} />)}
    </div>;
};

const Job = ({job}) => {
    const {setMarkingJobDone, setSkipping, setScheduling} = useWorkViewContext();
    const directionsTo = useDirectionsTo();
    const {offlineSupported} = useOffline();
    const navigate = useNavigate();

    return <div className="flex flex-row items-top justify-between py-2">
        <div>
            <Title customer={job.customer} addressSegments={2} />
            <Money pence={job.cost + (job?.itemisationAdjustment?.amount ?? 0)}
                className="ml-2 bg-brand rounded-full px-2 py-1 text-xs text-white dark:text-black"
            />
            <br />
            <Subtitle customer={job.customer} className="text-muted" /><br />
            <Services services={job.services} className="text-muted" /><br />
        </div>
        <div>
            <Dropdown options={[
                {
                    title: 'Mark as done',
                    icon: 'Check',
                    onClick: () => setMarkingJobDone(job),
                    availableOffline: offlineSupported,
                },
                {
                    title: 'Directions',
                    icon: 'Route',
                    onClick: () => directionsTo(job.customer.address),
                },
                {
                    div: true,
                },
                {
                    title: 'Skip job',
                    icon: 'Forward',
                    onClick: () => setSkipping(job),
                },
                {
                    title: 'Reschedule job',
                    icon: 'CalendarPlus',
                    onClick: () => setScheduling(job),
                    role: Roles.Manager,
                },
                {
                    div: true,
                },
                {
                    title: 'View customer',
                    icon: 'User',
                    onClick: () => navigate(getEntityLink('Customers/Customer', job.customer.id)),
                    role: Roles.Manager,
                },
                {
                    title: 'View quote',
                    icon: 'ClipboardCheck',
                    onClick: () => navigate(getEntityLink('Quotes/Quote', job.quoteId)),
                    role: Roles.Manager,
                    hidden: !job.quoteId,
                }
            ]} />
        </div>
    </div>
}

export default WorkWidget;
